import {Component, inject} from '@angular/core';
import {PaymentMethodsBaseComponent} from "../payment-methods-base.component";
import {GameService} from "../../../services/game.service";
import {AgGridAngular} from "ag-grid-angular";
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from "@angular/material/card";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatButton} from "@angular/material/button";
import {ReactiveFormsModule} from "@angular/forms";
import {ContainerComponent, RowComponent, ColComponent} from "@coreui/angular";
import {ChooseYourGameComponent} from "../../../components/choose-your-game/choose-your-game.component";

@Component({
  selector: 'app-game-admin-payment-methods',
  standalone: true,
  imports: [
    AgGridAngular,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardContent,
    MatFormField,
    MatLabel,
    MatInput,
    MatButton,
    ReactiveFormsModule,
    ContainerComponent,
    RowComponent,
    ColComponent,
    ChooseYourGameComponent
  ],
  templateUrl: '../payment-methods.component.html',
  styleUrl: './game-admin-payment-methods.component.scss'
})
export class GameAdminPaymentMethodsComponent extends PaymentMethodsBaseComponent {
  private gameService: GameService = inject(GameService);

  constructor() {
    super();
    this.game = this.gameService.activeGame();
    if (this.game) {
      this.searchPaymentMethods();
    }
  }
}
